import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	roleRestrictionsHeading: {
		id: 'polaris-components-quickstart.task-description-role-restrictions.role-restrictions-heading.non-final',
		defaultMessage: 'Role restrictions',
		description: 'Heading for the role restrictions section',
	},
});
